import { AppRouter } from 'common/types/globalTypes';

export const getNavigationLink = (module: AppRouter, inputText: string) => {
  const searchInput = encodeURIComponent(inputText);
  switch (module) {
    case 'FILE_CABINET':
      return `/doc/fileCabinet?t=${searchInput}`;
    case 'DOCUMENT_POOL_FILE_LOADER':
      return `/doc/documentAssignment?t=${searchInput}`;
    case 'APPROVALS':
      return `/approvals?t=${searchInput}`;
    case 'APPROVAL_HISTORY':
      return `/approval_history?t=${searchInput}`;
    case 'TRANSACTION_SIGNING':
      return `/signing?t=${searchInput}`;
    case 'PAY_CYCLE':
      return `/pay/payment_cycle?t=${searchInput}`;
    case 'PAYMENT_TRACKING':
      return `/pay/payment_tracking?t=${searchInput}`;
    case 'POSTED_TRANSACTIONS':
      return `../../postingTracker/history?t=${searchInput}`;
    case 'PURCHASE_ORDER':
      return `/purchase-orders?t=${searchInput}`;
    case 'TRAVEL_AUTHORIZATION':
      return `/ta/travel-plan?t=${searchInput}`;
    case 'TRIP_BREAKDOWN':
      return `/ta/trip-breakdown?t=${searchInput}`;
    default:
      return `/404`;
  }
};
